<template>
  <div class="h-100"
    v-loading="loading"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
  >
    <div class="pa-5 wr-body" style="overflow-y: scroll;" v-if="conversationList.length > 0">
      <ChatConversationItem
        v-for="(conversation, index) in conversationList"
        :conversation="conversation"
        :key="index"
      />
    </div>
    <div class="h-100 d-flex flex-grow-1 align-items-center justify-content-center" v-else>
      <span class="text-subtitle-1">Chưa có thông tin hội thoại</span>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/lib/http-common";
import ChatConversationItem from "./ChatConversationItem.vue";

export default {
  components : {
    ChatConversationItem
  },
  data() {
    return{
      conversationList : [],
      accountList : [],
      loading : true,
    }
  },
  props : {
    contact : {
      type : Object,
      require : true,
    }
  },
  methods: {
    async fetchConversationChat(){
      this.loading = true;
      let config = {
          headers: {
              "evn-token": "NDNDUXVJdTV3YXpYeVVCcGpsN2tYQSUzRCUzRDpBZ1NxV29Xd0xXViUyRjZwcmI3N2Y4ZVElM0QlM0Q",
          },
      };
      const apiUrl = this.app.user.companyCode === 'sota'
          ? `api/contact/search-chat-sota?phone=${this.contact?.phone}&email=${this.contact.email}`
          : `api/contact/search-chat?phone=${this.contact?.phone}&email=${this.contact.email}&companyCode=${this.app.user.companyCode}`;

      const res = await HTTP.post(apiUrl, {}, config);
      if (res && res.data) {
        if(Object.keys(res.data).length === 0){
          this.loading = false;
          this.conversationList = []
        }else{
          this.conversationList = res.data.conversations;
          this.loading = false
        }
      }
    },
  },
  created(){
    
  },
  mounted(){
    this.fetchConversationChat();

  }
};
</script>
<style>
.wr-body{
  height: calc(80vh - 102px)!important;
}
</style>